import React from 'react';
import './index.scss';
import MaximizedFrameOld from '../../base/maximized';
import MinimizedFrame from '../../frames/minimized/';
import MinimizedFrameOld from '../../base/minimized';
import Tip from './tip';
import Option from './option/';
import * as ContactActions from './actions';
import { VIEW_MODES } from '../../views/types';
import drawMinimizedView from './drawMinimizedView';
import Tracker from '../../../genesys/tracker';
import { INVITE_TYPE } from '../../../genesys/types';

class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.componentTimeout = null;

        Tracker.sendGAEvent('showWidget', { engagementID: props.viewConfig.engagementID });

        this.state = {
            callNumberVisible: false,
            minimizedView: drawMinimizedView(this.props.viewConfig.contactIconOptions.drawRatio)
        };
    }

    componentWillUnmount() {
        clearTimeout(this.componentTimeout);
    }

    onCallClick(phoneOptions) {
        if (
            this.props.viewConfig.contactOptions.phoneOptions.phoneShowText &&
            !this.state.callNumberVisible
        ) {
            ContactActions.showCallNumber();
            this.setState({ callNumberVisible: true });
        } else {
            this.callAndHide(phoneOptions);
        }
    }

    callAndHide(phoneOptions) {
        if (phoneOptions.phoneCountdown) {
            this.componentTimeout = setTimeout(
                () => this.hide(),
                parseInt(phoneOptions.phoneCountdown) * 1000
            );
        }
        ContactActions.call(phoneOptions.phoneNumber);
    }

    hide() {
        this.props.events.close('phoneCountdownTimeout');
    }

    render() {
        const componentTitle = 'Kontakt',
            {
                mode,
                layerConfig,
                viewConfig,
                minConf = viewConfig.contactIconOptions,
                maxConf = viewConfig.contactOptions,
                options
            } = this.props;

        const events = {
            ...this.props.events,
            close: null
        };

        switch (mode) {
            case VIEW_MODES.MINIMIZED:
                clearTimeout(this.componentTimeout);

                if (layerConfig.isInitView && this.state.minimizedView === 0) {
                    return (
                        <div className="contact-minimized">
                            {minConf && minConf.tipAvailable && layerConfig.isInitView ? (
                                <div className="tip">
                                    <Tip
                                        viewConfig={viewConfig.contactIconOptions}
                                        layerConfig={layerConfig}
                                        options={options}
                                    />
                                </div>
                            ) : null}
                            <MinimizedFrameOld
                                type="bar"
                                title={componentTitle}
                                events={events}
                                delays={{
                                    showAfter: layerConfig.isInitView
                                        ? parseInt(minConf.showAfter)
                                        : 0,
                                    hideAfter: layerConfig.isInitView
                                        ? parseInt(minConf.hideAfter)
                                        : 0
                                }}
                            />
                        </div>
                    );
                } else {
                    return (
                        <MinimizedFrame
                            config={minConf}
                            events={events}
                            ignoreDelays={!layerConfig.isInitView}
                            delays={{
                                showAfter: parseInt(minConf.showAfter),
                                hideAfter: parseInt(minConf.hideAfter)
                            }}
                            pulseAfter={minConf.pulseAfter ? minConf.pulseAfter : -1}
                            icon={maxConf.chatAvailable ? 'chat' : ''}
                        />
                    );
                }

            case VIEW_MODES.MAXIMIZED:
                if (
                    !maxConf.phoneAvailable &&
                    !maxConf.cmbAvailable &&
                    !maxConf.chatAvailable &&
                    !maxConf.smsLeadAvailable
                ) {
                    return null;
                }
                Tracker.sendViewResult(INVITE_TYPE.WIDGET, 'openWidget', 'CONTACT');
                return (
                    <MaximizedFrameOld
                        type="small"
                        title={componentTitle}
                        events={events}
                        delays={{
                            showAfter: layerConfig.isInitView ? parseInt(maxConf.showAfter) : 0,
                            hideAfter: layerConfig.isInitView ? parseInt(maxConf.hideAfter) : 0
                        }}
                    >
                        <div className="contact-options">
                            {maxConf.phoneAvailable &&
                            maxConf.phoneOptions &&
                            maxConf.phoneOptions.phoneText ? (
                                <Option
                                    type="tel"
                                    text={
                                        maxConf.phoneOptions.phoneShowText &&
                                        !this.state.callNumberVisible
                                            ? maxConf.phoneOptions.phoneShowText
                                            : maxConf.phoneOptions.phoneText
                                    }
                                    click={() => this.onCallClick(maxConf.phoneOptions)}
                                />
                            ) : null}

                            {maxConf.cmbAvailable &&
                            maxConf.cmbOptions &&
                            maxConf.cmbOptions.cmbText ? (
                                <Option
                                    type="cmb"
                                    text={maxConf.cmbOptions.cmbText}
                                    click={ContactActions.callMeBack}
                                />
                            ) : null}

                            {maxConf.chatAvailable &&
                            maxConf.chatOptions &&
                            maxConf.chatOptions.chatText ? (
                                <Option
                                    type="chat"
                                    text={maxConf.chatOptions.chatText}
                                    click={() =>
                                        ContactActions.chat(
                                            viewConfig?.chatUserData?.category ?? '',
                                            viewConfig
                                        )
                                    }
                                />
                            ) : null}

                            {maxConf.smsLeadAvailable &&
                            maxConf.smsLeadOptions &&
                            maxConf.smsLeadOptions.smsText ? (
                                <Option type="lead" text={maxConf.smsLeadOptions.smsText} />
                            ) : null}
                        </div>
                    </MaximizedFrameOld>
                );
            default:
                return null;
        }
    }
}

export default Contact;
